module.exports = __webpack_public_path__ + "static/media/home-blue-grid-2.ac36385e.svg";